import * as service from './service'
export default {
  namespace: 'recruitWeedout',
  state: {
    weedOutData: {
      reason: '',
      title: '',
      eliminateValue: '',
      depositStatus: 0
    }
  },
  effects: {
    * queryCriminal ({ payload }, { call, put }) {
      const res = yield call(service.queryCriminal, payload)
      yield put({
        type: 'save',
        payload: {
          weedOutData: res.data.data
        }
      })
    },
    * getIsExistDdbit ({ payload }, { call, put }) {
      const res = yield call(service.getIsExistDdbit, payload)
      yield put({
        type: 'save',
        payload: {
          isExistDdbit: res.data.data
        }
      })
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
